module.exports = __webpack_public_path__ + "img/career-history.f3d436c2.svg";